import type { IApiCatalogItem, ICatalogItem } from 'src/interfaces';

export const mapApiToCatalogItem = ({ man_hours, ...rest }: IApiCatalogItem): ICatalogItem => {
  return {
    ...rest,
    manHours: man_hours,
  };
};
